import { render, staticRenderFns } from "./commonUpload.vue?vue&type=template&id=508c959d&scoped=true"
import script from "./commonUpload.vue?vue&type=script&lang=js"
export * from "./commonUpload.vue?vue&type=script&lang=js"
import style0 from "./commonUpload.vue?vue&type=style&index=0&id=508c959d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c959d",
  null
  
)

export default component.exports